import { fetch } from 'whatwg-fetch'
import { chartPlugins } from './chart-plugins'
import { getData, getOptions, getResponsiveOptions } from './chart-settings'
import { formatNumber } from './utils/format-number'
import Chartist from 'chartist'
import OrderSuggestions from '../validation/OrderSuggestions'

export class EpexChart {
  constructor () {
    this.chartElement = document.querySelector('#epex')
    this.nettoSwitch = document.querySelector('#netto-button')
    this.bruttoSwitch = document.querySelector('#brutto-button')
    this.currentDateSelector = document.querySelector('.current-date')
    this.prevDateButton = document.querySelector('.prev-date')
    this.nextDateButton = document.querySelector('.next-date')

    this.plzChooser = document.querySelector('.plz-chooser button')
    this.plzChooserInput = document.querySelector('.plz-chooser input.epex-plz')
    this.streetChooserInput = document.querySelector('.plz-chooser input.epex-street')
    this.plzControls = document.querySelector('.plz-controls')

    this.notesPrices = document.querySelector('.epex-footer .note-prices')
    this.notesLocalizedPrices = document.querySelector('.epex-footer .note-localized-prices')

    this.isBrutto = false
    this.nettoDataset = []
    this.bruttoDataset = []
    this.activeDataset
    this.todaysDate
    this.changedDate
    this.storageDate
    this.index = 0

    this.plzMode = false
    this.fixedPrices = {}

    chartPlugins()
    window._epxchart = this;
  }

  init () {
    const url = `${window.location.origin}/?type=9998`
    this.url = url
    this.fixedPriceUrl = `${window.location.origin}/?type=9996`

    this.initEventListeners(url)

    this.buildChart(url)
  }

  initEventListeners (url) {

    this.plzControls.querySelector("a").addEventListener('click', event => {
      event.preventDefault();
      this.disablePlzMode();
    })

    this.plzChooser.addEventListener('click', event => {
      let valStr = this.plzChooserInput.value
      let valStreet = this.streetChooserInput.value

      if (valStr.length != 5) return
      
      let val = parseInt(valStr)
      if (isNaN(val)) return

      if (valStreet != "") {
        valStreet = valStreet.trim()
        let arr = valStreet.split(" ")
        if (arr.length > 1) {
          let last = arr[arr.length-1]
          if (!isNaN(parseInt(last))) {
            arr.pop()
          }
          valStreet = arr.join(" ")
          valStreet = valStreet.trim()
        }
        this.streetChooserInput.value = valStreet
      }

      this.getFixedPrices(val, valStreet) 
    })
    
    // Toggle to brutto prices
    this.bruttoSwitch.addEventListener('change', event => {
      if (!this.isBrutto) {
        this.isBrutto = true
        this.updateChartDataset()
      }
    })

    // Toggle to netto prices
    this.nettoSwitch.addEventListener('change', event => {
      if (this.isBrutto) {
        this.isBrutto = false
        this.updateChartDataset()
      }
    })

    // Click for the prices of the previous Day
    this.prevDateButton.addEventListener('click', () => this.prevDate(url))

    // Click for the prices of the next Day
    this.nextDateButton.addEventListener('click', () => this.nextDate(url))
  }

  // Get data from url
  // Build chart from dataset
  buildChart (url) {
    return fetch(url)
      .then((response) => response.json())
      .catch((error) => console.error(`EPEX-Preise konnten nicht geladen werden: ${error}`))
      .then((res) => {
        if (!this.todaysDate) {
          this.todaysDate = new Date(res[1].date * 1000)
          this.storageDate = new Date(res[1].date * 1000)
        }

        if (!this.currentDateSelector.innerHTML) {
          this.setCurrentDate(this.todaysDate)
        }

        this.bruttoDataset = []
        this.nettoDataset = []

        return this.createPriceDatasets(res[0].prices)
      })
      .then(() => {
        this.createCurrentPriceDataset()
        this.setPriceHighlights()
      })
      .then(() => {

        this.singleChart = new Chartist.Bar('#epex', getData(this.currentDataset), getOptions(Math.max.apply(Math, this.bruttoDataset), Math.min.apply(Math, this.nettoDataset)))

        // Once the chart is fully created we reset the sequence
        this.singleChart.on('created', () => {
          this.highlightBarForCurrentHour(this.currentHour)

          this.fadeInTooltips()
        })
      })
  }

  prevDate (url) {
    this.changedDate = new Date(this.storageDate.setDate(this.storageDate.getDate() - 1))

    this.dateChangeHandler(url)
  }

  nextDate (url) {
    this.changedDate = new Date(this.storageDate.setDate(this.storageDate.getDate() + 1))

    this.dateChangeHandler(url)
  }

  postalCodeChangeHandler (plz) {

  }

  disablePlzMode() {
    this.plzMode = false
    this.plzControls.classList.remove("enabled")

    this.notesPrices.classList.remove("disabled")
    this.notesLocalizedPrices.classList.remove("enabled")
    this.notesLocalizedPrices.classList.add("disabled")
    this.streetChooserInput.classList.add("disabled")

    this.plzChooserInput.value=""
    this.streetChooserInput.value=""
    this.updateChartDataset()
  }

  getFixedPrices(plz, street = "") {

    let newUrl = `${this.fixedPriceUrl}&tx_voltegoprice_fixed_price[postal_code]=${plz}`

    if (street != "") {
      newUrl+=`&tx_voltegoprice_fixed_price[street]=${encodeURIComponent(street)}` 
    }

    fetch(newUrl)
      .then((response) => response.json())
      .catch((error) => { 
        console.error(`Festpreise konnten nicht geladen werden: ${error}`)
      }).then( async (res) => {
        if (res.needsStreet == true) {
          this.streetChooserInput.classList.remove("disabled")

        } else {

          const { success, cities } = await OrderSuggestions._getSuggestions('cities', { postal_code: plz })

          this.plzMode = true
          let field = this.plzControls.querySelector("span")
          let fieldCity = this.plzControls.querySelector("span.city")
          field.innerText = plz
          fieldCity.innerText = cities[0]

          this.plzControls.classList.add("enabled");

          this.notesPrices.classList.add("disabled");
          this.notesLocalizedPrices.classList.add("enabled");
          this.notesLocalizedPrices.classList.remove("disabled");

          this.changedDate = new Date(this.storageDate.getDate());

          this.fixedPrices = res

          this.streetChooserInput.classList.add("disabled")
          this.plzChooserInput.value="";
          this.streetChooserInput.value=""

          //console.log ("FixedPrices--------------")
          //console.log (res)

          this.updateChartDataset();
        }
      })
  }

  dateChangeHandler (url) {
    Array.prototype.slice.call(document.querySelectorAll('.tooltip')).forEach((tip) => {
      tip.parentNode.removeChild(tip)
    })

    this.index++
    this.setCurrentDate(this.changedDate)

    const newUrl = `${url}&tx_voltegoprice_price[day]=${this.currentDate}&tx_voltegoprice_price[month]=${this.currentMonth}&tx_voltegoprice_price[year]=${this.currentYear}`

    this.singleChart.detach()
    this.buildChart(newUrl)
  }

  updateChartDataset () {
    this.createCurrentPriceDataset()

    this.singleChart.data.series[0] = this.currentDataset
    this.setPriceHighlights()
    this.singleChart.update()

    this.highlightBarForCurrentHour(this.currentHour)
    this.fadeInTooltips()
  }

  createCurrentPriceDataset() {

    console.log ("create CurrentPriceDataset")
    console.log ("brutto: " + this.isBrutto)

    let current = !this.isBrutto ? this.nettoDataset : this.bruttoDataset
    this.currentDataset = current;

    //console.log (this.currentDataset)

    if (this.plzMode == true) {
      /*
      console.log(this.fixedPrices)
      fees_and_taxes: 3.624
      metering: 0.00024
      operation: 9.31013240008
      plz: "12312"
      voltego: 2.975
      */ 
      let arr = []
      let fp = this.fixedPrices
      let f = 1
      if (this.isBrutto) {
        f = 1.19
      }
      this.currentDataset.forEach(price => {
        let p = parseFloat(price)
        p+=fp.fees_and_taxes * f
        p+=fp.metering * f
        p+=fp.operation * f
        p+=fp.voltego * f

        arr.push(p)
      })
      this.currentDataset = arr
    }
  }

  createPriceDatasets (response) {

    response.forEach(price => {
      this.bruttoDataset.push(price.priceAmount * 1.19)
      this.nettoDataset.push(price.priceAmount)

      if (this.currentHour === price.priceHour) {
        if (this.isBrutto) {
          this.putCurrentValue(price.priceAmount * 1.19)
        }
        else {
          this.putCurrentValue(price.priceAmount)
        }

        this.bruttoSwitch.addEventListener('change', event => {
          this.putCurrentValue(price.priceAmount * 1.19)
        })
        this.nettoSwitch.addEventListener('change', event => {
          this.putCurrentValue(price.priceAmount)
        })
        price.isActive = true
      }
    })
  }

  putCurrentValue (value) {
    const selectors = document.getElementsByClassName('price-per-hour')

    Object.keys(selectors).map(key => {
      selectors[key].innerHTML = formatNumber(value)
    })
  }

  fadeInTooltips () {
    const texts = Array.prototype.slice.call(this.chartElement.querySelectorAll('.ct-barlabel'))

    setTimeout(() => {
      texts.forEach(singleText => {
        singleText.classList.add('is-visible')
      })
    }, 100)
  }

  putMaxValue () {

    let maxValue = Math.max.apply(Math, this.currentDataset)

    const selectors = document.getElementsByClassName('highest-price')

    Object.keys(selectors).map(key => {
      selectors[key].innerHTML = formatNumber(maxValue)
    })
  }

  // Output the lowest value of the array in given selector
  putMinValue () {
    const minValue = Math.min.apply(Math, this.currentDataset)
    const selectors = document.getElementsByClassName('lowest-price')

    Object.keys(selectors).map(key => {
      selectors[key].innerHTML = formatNumber(minValue)
    })
  }

  // Helper function
  // See functions below
  setPriceHighlights () {
    this.putMaxValue()
    this.putMinValue()
    this.putAvgValue()
  }

  // Hightlighting the price of the current Hour
  highlightBarForCurrentHour (hour) {
    const lines = Array.prototype.slice.call(this.chartElement.querySelectorAll('line'))

    if (lines[hour] && this.todaysDate.getDate() === this.storageDate.getDate()) {
      lines[hour].style.opacity = 1
    }

    // Centering the highlighted bar on mobile
    if (window.innerWidth <= 1024 && this.todaysDate.getDate() === this.storageDate.getDate()) {
      const epexForm = this.chartElement.getBoundingClientRect()
      const priceWrapper = document.querySelector('.price-wrapper')
      const leftOfLine = lines[hour].getBoundingClientRect().left

      priceWrapper.scrollLeft = leftOfLine - epexForm.left - 36
    }
  }

  // Output the average value of the array in given selector
  putAvgValue () {
    this.activeDataset = this.currentDataset
    if (this.activeDataset.length) {
      const sumValue = this.activeDataset.reduce((previous, current) => parseFloat(current) + parseFloat(previous))
      const avgValue = sumValue / this.activeDataset.length
      const selector = document.querySelector('.average-price')
      selector.innerHTML = formatNumber(avgValue)
    }
  }

  // Gets the current date and outputs it into the given selector
  setCurrentDate (date) {
    this.currentHour = date.getHours()
    this.currentDate = date.getDate()
    this.currentMonth = (date.getMonth() + 1)
    this.currentYear = date.getFullYear()

    if (this.currentDate < 10) {
      this.currentDate = `0${this.currentDate}`
    }

    if (this.currentMonth < 10) {
      this.currentMonth = `0${this.currentMonth}`
    }

    this.currentDayDE = `${this.currentDate}.${this.currentMonth}.${this.currentYear}`

    this.currentDateSelector.innerHTML = this.currentDayDE
  }
}

export function chart () {
  if (document.querySelector('#epex') === null) {
    return
  }

  const epexChart = new EpexChart()

  epexChart.init()
}
